import { IOProps } from 'react-compose-io'
import { FormFieldsProps } from '../../../types/regraApiType'
import { FieldsTipoParametroTransformacaoApi } from '../FieldsTipoParametroTransformacaoApi'
import { FieldsSubstituirTransformacaoApiIO } from './FieldsSubstituirTransformacaoApi.IO'

export type FieldsSubstituirTransformacaoApiProps = {
  indexItensRegraForm: number
  itensCampo: FormFieldsProps[]
  cabecalhos: string[]
}

export function FieldsSubstituirTransformacaoApiView({
  _io,
  indexItensRegraForm,
  itensCampo,
  cabecalhos
}: IOProps<FieldsSubstituirTransformacaoApiIO, FieldsSubstituirTransformacaoApiProps>) {
  return (
    <>
      {_io.acaoSelecionada[indexItensRegraForm]?.operacaoId === 'SubstituirOperacao' && (
        <FieldsTipoParametroTransformacaoApi
          itensCampo={itensCampo}
          control={_io.control}
          cabecalhos={cabecalhos}
          indexItensRegraForm={indexItensRegraForm}
          itensRegraTransformacaoForm={_io.acaoSelecionada}
        />
      )}
    </>
  )
}
